<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card v-if="visit">
      <v-card-title>
        <span class="text-h5">Визит {{ visit.public_id }}</span>
        <v-chip
          small
          dark
          class="ml-3"
          :color="visit.state_color"
        >
          {{ visit.state_text }}
        </v-chip>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr><td>Заголовок</td><td>{{ visit.title }}</td></tr>
              <tr v-if="visit.purpose">
                <td>Цель</td><td>{{ visit.purpose }}</td>
              </tr>
              <tr><td>Начало окна</td><td>{{ visit.starts_at }}</td></tr>
              <tr><td>Конец окна</td><td>{{ visit.ends_at }}</td></tr>
              <tr><td>Сторона</td><td>{{ visit.side_text }}</td></tr>
              <tr><td>Место-отправитель</td><td>{{ placeName(visit.from_place_id) }}</td></tr>
              <tr><td>Место-приёмник</td><td>{{ placeName(visit.to_place_id) }}</td></tr>
              <tr v-if="visit.reject_reason">
                <td>Причина отказа</td><td>{{ visit.reject_reason }}</td>
              </tr>
              <tr v-if="visit.confirmed_by">
                <td>Подтвердил</td><td>{{ visit.confirmed_by }}</td>
              </tr>
              <tr v-if="visit.confirmed_at">
                <td>Подтверждён</td><td>{{ visit.confirmed_at }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <template v-if="visit.side === 'from' && visit.participants">
          <div class="text-subtitle-1 mt-4 mb-2">
            Участники
          </div>
          <v-data-table
            :headers="participant_headers"
            :items="visit.participants"
            dense
            no-data-text="Нет участников"
            hide-default-footer
          >
            <template v-slot:item.state_text="{item}">
              {{ item.state_text }}
            </template>
          </v-data-table>
        </template>
        <template v-else-if="visit.summary">
          <div class="text-subtitle-1 mt-4 mb-2">
            Сводка участников
          </div>
          <v-data-table
            :headers="summary_headers"
            :items="visit.summary"
            dense
            no-data-text="Нет данных"
            hide-default-footer
          />
        </template>

        <div class="mt-4">
          <v-btn
            v-if="Number(visit.state) === 0"
            color="primary"
            class="mr-2"
            @click="openAction('submit')"
          >
            Отправить
          </v-btn>
          <v-btn
            v-if="Number(visit.state) === 0"
            color="error"
            outlined
            class="mr-2"
            @click="openAction('cancel')"
          >
            Отменить
          </v-btn>
          <v-btn
            v-if="Number(visit.state) === 1"
            color="primary"
            class="mr-2"
            @click="openAction('confirm')"
          >
            Подтвердить
          </v-btn>
          <v-btn
            v-if="Number(visit.state) === 1"
            color="error"
            outlined
            class="mr-2"
            @click="openAction('reject')"
          >
            Отклонить
          </v-btn>
          <v-btn
            v-if="Number(visit.state) === 2 || Number(visit.state) === 4"
            color="error"
            outlined
            class="mr-2"
            @click="openAction('cancel')"
          >
            Отменить
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            @click="$router.go(-1)"
          >
            Назад
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <v-alert
      v-else-if="!loading"
      type="info"
      outlined
    >
      Визит не найден
    </v-alert>

    <v-dialog
      v-model="action_dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ action_title }}</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-if="action === 'submit'"
            v-model="action_form.comment"
            label="Комментарий (необязательно)"
            outlined
            dense
            rows="2"
            auto-grow
          />
          <template v-if="action === 'confirm'">
            <v-alert
              type="info"
              outlined
              dense
            >
              Допускается только сужение периода и точек
            </v-alert>
            <skud-point-select
              v-model="action_form.narrowed_point_ids"
              :place-id="placeId"
              label="Точки прохода (подмножество исходных)"
            />
            <skud-date-field
              v-model="action_form.narrowed_starts_at"
              label="Начало окна (не раньше исходного)"
              with-time
            />
            <skud-date-field
              v-model="action_form.narrowed_ends_at"
              label="Конец окна (не позже исходного)"
              with-time
            />
          </template>
          <v-textarea
            v-if="action === 'reject'"
            v-model="action_form.reason"
            label="Причина отказа * (5..500 символов)"
            counter="500"
            maxlength="500"
            outlined
            dense
            rows="3"
          />
          <v-textarea
            v-if="action === 'cancel'"
            v-model="action_form.reason"
            label="Причина отмены (необязательно)"
            counter="500"
            maxlength="500"
            outlined
            dense
            rows="2"
            auto-grow
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="action_loading"
            @click="runAction"
          >
            <span class="mx-4">Выполнить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="action_dialog = false"
          >
            <span class="mx-4">Закрыть</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Страница визита: просмотр + действия по состоянию
// (draft 0: submit/cancel; pending 1: confirm/reject; confirmed 2 / active 4: cancel).
// Место — из query.place (его передаёт список), fallback — store.skud_place.
import moment from 'moment'
import { SkudVisitService } from '@/views/skud/shared/services/skud-visit-service'
import { loadPlaces, placeName } from '@/views/skud/shared/services/skud-places-service'
import SkudPointSelect from '@/views/skud/components/SkudPointSelect.vue'
import SkudDateField from '@/views/skud/components/SkudDateField.vue'

const ACTION_TITLES = {
  submit: 'Отправить на подтверждение',
  confirm: 'Подтвердить визит',
  reject: 'Отклонить визит',
  cancel: 'Отменить визит'
}

export default {
  name: 'SkudVisitView',
  components: {
    SkudPointSelect,
    SkudDateField
  },
  data () {
    return {
      service: null,
      visit: null,
      loading: false,
      places_ready: false,
      action: null,
      action_dialog: false,
      action_loading: false,
      action_form: {},
      participant_headers: [
        { value: 'subject_ref', text: 'Субъект' },
        { value: 'group_ref', text: 'Группа' },
        { value: 'role_code', text: 'Роль' },
        { value: 'state_text', text: 'Состояние' }
      ],
      summary_headers: [
        { value: 'group_ref', text: 'Группа' },
        { value: 'role_code', text: 'Роль' },
        { value: 'count', text: 'Количество' }
      ]
    }
  },
  computed: {
    placeId () {
      return this.$route.query.place || this.$store.state.skud_place
    },
    action_title () {
      return ACTION_TITLES[this.action] || ''
    }
  },
  mounted () {
    this.service = new SkudVisitService()
    loadPlaces().then(() => { this.places_ready = true })
    this.load()
  },
  methods: {
    placeName (id) {
      return this.places_ready ? placeName(id) : id
    },
    async load () {
      if (!this.placeId) return
      this.loading = true
      this.visit = await this.service.getVisit(this.placeId, this.$route.query.id)
      this.loading = false
      if (!this.visit) {
        this.$store.commit('snackbar', 'Ошибка при получении данных')
      }
    },
    openAction (action) {
      this.action = action
      this.action_form = { comment: '', reason: '', narrowed_point_ids: [], narrowed_starts_at: '', narrowed_ends_at: '' }
      this.action_dialog = true
    },
    async runAction () {
      if (this.action === 'reject') {
        const reason = (this.action_form.reason || '').trim()
        if (reason.length < 5 || reason.length > 500) {
          this.$store.commit('snackbar', 'Причина отказа — от 5 до 500 символов')
          return
        }
      }
      const id = this.$route.query.id
      let res = null
      this.action_loading = true
      if (this.action === 'submit') {
        res = await this.service.submitVisit(this.placeId, id, this.action_form.comment)
      } else if (this.action === 'confirm') {
        res = await this.service.confirmVisit(this.placeId, id, {
          visit_id: id,
          narrowed_point_ids: this.action_form.narrowed_point_ids.length ? this.action_form.narrowed_point_ids : null,
          narrowed_starts_at: this.action_form.narrowed_starts_at ? moment(this.action_form.narrowed_starts_at).toISOString() : null,
          narrowed_ends_at: this.action_form.narrowed_ends_at ? moment(this.action_form.narrowed_ends_at).toISOString() : null
        })
      } else if (this.action === 'reject') {
        res = await this.service.rejectVisit(this.placeId, id, this.action_form.reason.trim())
      } else if (this.action === 'cancel') {
        res = await this.service.cancelVisit(this.placeId, id, this.action_form.reason)
      }
      if (!res) return
      this.action_loading = false
      if (res.ok) {
        this.action_dialog = false
        this.$store.commit('snackbar', 'Успешно')
        this.load()
      } else {
        this.$store.commit('snackbar', res.error)
      }
    }
  }
}
</script>
